import { useHistory } from "react-router-dom";
import React, { useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import Switch from "react-switch";
import {useShopContext} from "../contexts/ShopContext";

export default function NavbarShop() {

  var current = new Date();
  var timeHours = current.getHours();

  const history = useHistory();
  const [error, setError] = useState("");
  const { currentUser, logout } = useAuth();
  const shopContext = useShopContext();
  const [isToggled, setIsToggled] = useState(timeHours < 12 ? false:true);
  const onToggle = () => {
    
    setIsToggled(!isToggled)
    shopContext.SetIsDragsmark();
  };
  console.log(shopContext.IsDragsmark);


  async function handleLogout() {
    setError("");

    try {
      await logout();
      history.push("/login");
    } catch {
      setError("Failed to log out");
    }
  }

  function GoToAttendance() {
    history.push("/Attendance");
  }

  return (
    <div>
      <div className="Navbar">
        {/* Närvaro */}
        {/*<div
          className="PageSwitch"
          onClick={GoToAttendance}
        >
          Närvaro
        </div>*/}
        
        <div className="PageSwitch float-right" onClick={handleLogout}>
          Logga ut
        </div>
      </div>
      {
        /*
      <div className="SearchBar">
        <input type="text" name="" id="" placeholder="Sök..." />
      </div>
      */
      }
      <div className="PlaceSelect">
        <div style={isToggled? {color:'#1363df'} : {color:'white'}} className="PlaceSelectText" >Lingäll</div>
        <label>
          <Switch checkedIcon={false} uncheckedIcon={false} offColor='#1363df' onColor='#1363df' onChange={onToggle} checked={isToggled} />
        </label>
        <div style={isToggled? {color:'white'} : {color:'#1363df'}} className="PlaceSelectText" >Dragsmark</div>
      </div>
    </div>
  );
}
